import Button from "./Button";
import "../Info.css"
const AFUe = ()=>{
    return(
        <div className="infoalbum">
  <h1 className="title">APOCALYPSE: FOLLOW US</h1>
  <div className="infoal">
    <div className="infotext">
      <Button/>
      <p>- POBs = from <span className="colorunoa">8usd</span> <span className="colordosa"> 8 usd</span></p>
      <p className="ver">LIMITADO (ver. T)</p>
      <p>- Limited photobook (cd+pb) = <span className="colorunoa">10usd</span> <span className="colordosa"> 8 usd</span></p>
      <p>- Limited Photocard = <span className="colorunoa"> 5,5 usd</span> <span className="colordosa"> 10 usd</span></p>
      <p>- Agent card = <span className="colorunoa">1,5usd</span><span className="colordosa"> 2 usd</span></p>
      <p>- 4-cut = <span className="colorunoa">1,5usd</span> <span className="colordosa"> 3 usd</span></p>
      <p>- Spin Card = <span className="colorunoa">1,25usd</span> <span className="colordosa"> 2 usd</span></p>
      <p>- Postcard b&w (Set ot7) = <span className="colorunoa">0,5usd</span> c/u <span className="colordosa"> 7usd set</span></p>
      <p>- POB limited poster = <span className="colorunoa">1usd</span> <span className="colordosa"> 1 usd</span></p>
      <p className="ver">NORMAL (ver. H,E)</p>
      <p>- Photobook (cd+pb) = <span className="colorunoa">6,5usd</span> <span className="colordosa"> 6 usd</span></p>
      <p>- Photocard = <span className="colorunoa">2,5usd</span> <span className="colordosa"> 2 usd</span></p>
      <p>- Agent Card = <span className="colorunoa">1,5usd</span> <span className="colordosa"> 2 usd</span></p>
      <p>- POB limited poster = <span className="colorunoa">0,8usd</span> <span className="colordosa"> 1 usd</span></p>
      <p className="ver">PLATFORM</p>
      <p>- Sobre+ lyric sheet = <span className="colorunoa">1,4usd</span> <span className="colordosa"> 3 usd</span></p>
      <p>- Photocard = <span className="colorunoa"> 3,5 usd</span> <span className="colordosa"> 5 usd</span></p>
      <p>- PVC Photocard = <span className="colorunoa"> 4 usd</span> <span className="colordosa"> 5 usd</span></p>
    </div>
    <img src="https://down-ph.img.susercontent.com/file/ph-11134201-7qukw-lepj8yq52xk97c" alt="Album Cover" style={{ boxShadow: "3.5px 3.5px 0px rgb(217, 0, 0)" }} />
    <img src="https://i.pinimg.com/736x/1d/5f/eb/1d5feb071df9ceb87e6ebc324cc0015e.jpg" alt="Album Cover" style={{ boxShadow: "3.5px 3.5px 0px rgb(217, 0, 0)" }} />
  </div>
</div>
)
}

export default AFUe;